<template>
    <v-snackbar
            v-bind="$props"
            v-on="$listeners"
            color="error"
            multi-line
            :timeout="6000"
            top
    >
        <slot></slot>
        <v-btn
                dark
                flat
                @click.prevent.stop="$emit('input', false)"
        >
            <v-icon>close</v-icon>
        </v-btn>
    </v-snackbar>
</template>

<script>
    export default {
        name: "FailureSnackbar",
        props:{
            value:Boolean
        },
    }
</script>

<style scoped>

</style>